import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { AddressFormGroup } from '../../../../../models/forms/AddressFormGroup';
import { Address, BillAddress } from '../../../../../models/address.model';

import { AddressCardOptions } from './address-card-options.model';
import {
  BaryButtonComponent,
  BaryCardComponent,
  BaryInputEmailComponent,
  BaryInputPasswordComponent,
  BaryInputPhoneComponent,
  BaryInputSelectComponent,
  BaryInputTextComponent,
} from '../../../components';

import { TranslateDirective } from '../../../../../directives/translate.directive';

import { BaryAddressFormComponent } from '../../forms/bary-address-form/bary-address-form.component';
import { BaryDatePickerComponent } from '../../../components/bary-date-picker/bary-date-picker.component';
import { CardsModule } from 'ng-uikit-pro-standard';
import { PhoneFormatPipe } from '../../../../pipes/phone.pipe';
import { BillAddressFormGroup } from '../../../../../models/forms/BillAddressFormGroup';

@Component({
  selector: 'jhi-address-card',
  standalone: true,
  imports: [
    BaryCardComponent,
    TranslateModule,
    TranslateDirective,
    NgIf,
    BaryAddressFormComponent,
    BaryButtonComponent,
    BaryDatePickerComponent,
    BaryInputEmailComponent,
    BaryInputPasswordComponent,
    BaryInputPhoneComponent,
    BaryInputSelectComponent,
    BaryInputTextComponent,
    CardsModule,
    DatePipe,
    PhoneFormatPipe,
    CardsModule,
  ],
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.scss'],
})
export class AddressCardComponent {
  @Input() id!: string;
  @Input() addressForm?: AddressFormGroup | BillAddressFormGroup;
  @Input() options!: AddressCardOptions;
  @Input() isOrder: boolean = true;
  @Input() address!: Address | BillAddress;
  @Input() touched: boolean = false;
  @Input() isEditMode: boolean = true;
  @Input() switchButton = false;

  @Output() action = new EventEmitter<boolean>();

  public get title(): string {
    return !this.isOrder ? '' : this.isBillAdress(this.address) ? 'ADDRESS_CARD.BILL.TITLE' : 'ADDRESS_CARD.TITLE';
  }

  public isBillAdress(t: Address | BillAddress): t is BillAddress {
    return t instanceof BillAddress;
  }
}
